import React from 'react';
import { Link } from 'react-router-dom';

export class Wrapper extends React.Component 
{
    render() 
    {
        return (
            <div className="wrapper wrapper-content">
                <div className="container">
                    {this.props.children}
                </div>
            </div>
        )
    }
}

export class Row extends React.Component 
{
    constructor(props) 
    { 
        super(props); 
    }

    static defaultProps = 
    {
        className: "",
        style: {}
    };

    render() 
    {
        return (
            <div 
                className={"row " + this.props.className} 
                style={this.props.style}>

                {this.props.children}
            </div>
        )
    }
}

export class CheckBox extends React.Component
{
    constructor(props)
    {
        super(props);
    }

    static defaultProps = 
    {
        name: "",
        label: "",
        checked: false,
        onChange: function(){}
    };

    shouldComponentUpdate()
    {
        return false;
    }

    componentDidMount()
    {
        let self = this;
        
        let elem = document.querySelector('.js-switch');
        let switchery = new window.Switchery(elem, { color: '#1991eb', size: 'small' }); 
    
        elem.onchange = function() 
        {
            self.props.onChange({target: this});
        };
    }

    render() 
    {
        return (
            <div>
                <input 
                    type="checkbox" 
                    name={this.props.name} 
                    checked={this.props.checked} 
                    onChange={this.props.onChange} 
                    className="js-switch" />
                    
                <label className="ml-1">{this.props.label}</label>                                                                                     
            </div>
        )
    }
}

export class Column extends React.Component 
{
    constructor(props) 
    { 
        super(props); 
    }

    static defaultProps = 
    {
        size: "12",
        className: "",
        style: {}
    };

    render() 
    {
        var col = `col-${this.props.size}`;

        return (
            <div 
                className={col + " " + this.props.className} 
                style={this.props.style}>

                {this.props.children}
            </div>
        )
    }
}

export class IBox extends React.Component 
{
    constructor(props) 
    { 
        super(props); 
    }

    static defaultProps = 
    {
        className: "",
        style: {}
    };

    render() 
    {
        return (
            <div 
                className={"ibox " + this.props.className} 
                style={this.props.style}>

                {this.props.children}
            </div>
        )
    }
}

export class Title extends React.Component 
{
    constructor(props) 
    { 
        super(props); 
    }

    static defaultProps = 
    {
        className: "",
        style: {}
    };

    render() 
    {
        return (
            <div className={"ibox-title px-3 " + this.props.className} style={this.props.style}>
                {this.props.children}
            </div>
        )
    }
}

export class Content extends React.Component 
{
    constructor(props) 
    { 
        super(props); 
    }

    static defaultProps = 
    {
        className: "",
        style: {}
    };

    render() 
    {
        return (
            <div className={"ibox-content p-3 " + this.props.className} style={this.props.style}>
                {this.props.children}
            </div>
        )
    }
}

export class Button extends React.Component 
{
    constructor(props) 
    { 
        super(props); 
    }

    static defaultProps = 
    {
        type: "button",
        name: "",
        width: "auto",
        background: "",
        border: "",
        className: "",
        disabled: false,
        onClick: function(){}
    };

    render() 
    {
        return (      
            <button 
                type={this.props.type}
                name={this.props.name}
                onClick={this.props.onClick}  
                className={"btn btn-primary px-3 fs-14 " + this.props.className }
                style={{ width: this.props.width, backgroundColor: this.props.background, border: this.props.border }}
                disabled={this.props.disabled}
            >
                
                {this.props.children}
            </button>
        )
    }
}

export class Icon extends React.Component 
{
    constructor(props) 
    { 
        super(props); 
    }

    static defaultProps = 
    {
        name: "",
        className: "mr-2",
        color: ""
    };

    render() 
    {
        return (
            <i style={{ color: this.props.color}} className={"fa " + this.props.name + " " + this.props.className}></i>
        )
    }
}

export class Logo extends React.Component 
{
    constructor(props) 
    { 
        super(props); 
    }

    static defaultProps = 
    {
        className: ""
    };
    
    render() 
    {
        return (
            <img src="assets/images/logo-moisate.svg" className={this.props.className} style={{"height": "62px"}} />
        )
    }
}

export class Modal extends React.Component
{
    constructor(props) 
    { 
        super(props);
    }

    static defaultProps = 
    {
        isOpen: false,
        style: {},
        toggle: function(e){}
    };

    render()
    {
        return (
            <div className="modal inmodal" id="myModal" tabIndex="-1" role="dialog" aria-hidden="true" style={{display: (this.props.isOpen? "block": "none"), backgroundColor: "rgba(0,0,0,0.5)"}}>
                <div className="modal-dialog" style={this.props.style}>
                    <div className="modal-content animated bounceInDown" style={{borderRadius: "10px", boxShadow: "1px 1px 10px 0 rgba(0, 0, 0, 0.29)"}}>
                        <div className="modal-body text-center" style={{backgroundColor: "#fff", borderRadius: "10px"}}>
                            <button type="button" onClick={this.props.toggle} className="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span className="sr-only">Close</span></button>                                     
                                         
                            {this.props.children}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export class Radio extends React.Component
{
    constructor(props) 
    { 
        super(props); 
    }

    static defaultProps = 
    {
        name: "",
        value: "",
        selected: "",
        onClick: function(){}
    };

    render()
    {
        return (
            <input 
                type="radio" 
                name={this.props.name} 
                value={this.props.value}
                checked={this.props.value === this.props.selected} 
                onClick={this.props.onClick}
                disabled={this.props.disabled} />
        )
    }
}

export class Return extends React.Component 
{
    constructor(props) 
    { 
        super(props); 
    }

    static defaultProps = 
    {
        to: "/",
        width: "auto",
        className: ""
    };

    render() 
    {
        return (
            <Link 
                to={this.props.to} 
                className={"btn btn-outline btn-primary px-3 fs-14 " + this.props.className}
                style={{width: this.props.width}} >
                
                <Icon name="fa-arrow-left"/> {this.props.children ? this.props.children : "Voltar"}
            </Link>
        )
    }
}

export class Search extends React.Component 
{
    constructor(props) 
    { 
        super(props); 
    }

    static defaultProps = 
    {
        name: "buscar",
        value: "",
        placeholder: "Buscar",
        onChange: function(){},
        btnText: "Ok",    
        onClick: function(){}
    };
    
    render() 
    {
        return (
            <div className="input-group">
                <input 
                    type="text" 
                    name={this.props.name} 
                    value={this.props.value} 
                    onChange={this.props.onChange} 
                    placeholder={this.props.placeholder}  
                    className="form-control form-control-sm" /> 

                <span className="input-group-append"> 
                    <button 
                        type="button" 
                        name={"btn-" + this.props.name} 
                        className="btn btn-sm btn-primary fs-12" 
                        onClick={this.props.onClick}>
                        
                        {this.props.btnText}
                    </button> 
                </span>
            </div>
        )
    }
}

export class Select extends React.Component
{
    constructor(props) 
    { 
        super(props); 
    }

    static defaultProps = 
    {
        name: "",
        selected: "",
        placeholder: "",
        disabled: "",
        isTag: false,
        onChange: function(){}
    };

    render()
    {
        const data = this.props.data; 
        const selected = this.props.selected; 
        const disabled = this.props.disabled;
        let isTag = this.props.isTag;
        let html = "";
        let htmlSelecione = "";

        htmlSelecione = (<option>Selecione...</option>);
        
        if(typeof data.results !== "undefined"){

            if (data.results.length === 0){
                html = (<option selected disabled hidden></option>);
    
            } else if (data.results.length  > 0 && !isTag) {
    
                html = data.results.map(row =>
                    <option key={row.value} selected={row.value === selected} value={row.value}>{row.label}</option>
                );

            } else if (isTag) {
    
                html = data.results.map(row =>
                    <option key={row.value} selected={row.label === selected} value={row.value}>{row.label}</option>
                );

            }

        }

        

        return(
            <select 
                disabled={disabled}
                name={this.props.name} 
                onChange={this.props.onChange} 
                className="form-control m-b">

                <option selected={selected.length === 0} disabled hidden>{this.props.placeholder}</option>
                {htmlSelecione}
                {html}
            </select>
        )
    }
}

export class SelectCentroCusto extends React.Component
{
    constructor(props) 
    { 
        super(props); 
    }

    static defaultProps = 
    {
        name: "",
        selected: "",
        placeholder: "",
        disabled: "",
        onChange: function(){}
    };

    render()
    {
        const data = this.props.data; 
        const selected = this.props.selected; 
        const disabled = this.props.disabled;
        let html = "";
        let htmlSelecione = "";

        htmlSelecione = (<option>Selecione...</option>);
        
        if(typeof data !== "undefined"){

            if (data.length === 0){
                html = (<option selected disabled hidden></option>);
    
            } else if (data.length  > 0) {
    
                html = data.map(row =>
                    <option key={row.id} selected={row.id === selected} value={row.id}>{row.nome}</option>
                );

            } 

        }

        

        return(
            <select 
                disabled={disabled}
                name={this.props.name} 
                onChange={this.props.onChange} 
                className="form-control m-b">

                <option selected={selected.length === 0} disabled hidden>{this.props.placeholder}</option>
                {htmlSelecione}
                {html}
            </select>
        )
    }
}

export class NavHeader extends React.Component{
    constructor(props) 
    { 
        super(props); 
    }

    
    render(){
        const style={
            fontWeight: "bolder", 
            backgroundColor: "#f7f7f7", 
            padding: "3px"
        };

        return(
            <li style={style}>{this.props.children}</li>
        );
    }
}

export class TextArea extends React.Component {
    constructor(props) {
        super(props);
    }

    static defaultProps = {
        value: '',
        maxlength: 200,
        minLength: 0,
        rows: 12,
        cols: 40,
        id: "editor-texto",
        onChange: function () { },
        onBlur: function () { }
    }

    render() {
        return (
            <textarea id={this.props.id} rows={this.props.rows} cols={this.props.cols} value={this.props.value} maxLength={this.props.maxLength} minLength={this.props.minLength}
                onChange={this.props.onChange} onBlur={this.props.onBlur} />
        );
    }
}

export class ActionTables extends React.Component {
    constructor(props) {
        super(props);
    }

    static defaultProps = {
        name: "",
        width: "auto",
        padding: "2px",
        margin: "0 5px 0 5px",
        className: "",
        disabled: false,
        onClick: () => { }
    }

    render() 
    {
        return (      
            <button type="button" name={this.props.name} onClick={this.props.onClick}
                className={"btn btn-link " + this.props.className}
                style={{ width: this.props.width, padding: this.props.padding, margin: this.props.margin }}
                disabled={this.props.disabled}
            >
                {this.props.children}
            </button>
        )
    }
}


